import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  gap: 24px;
  &.vertical {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
`;

export const CardButton = styled.button`
  background: #ffffff;
  border-radius: 4px;
  color: #5b36f2;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  border: 2px solid #5b36f2;
  padding: 12px 24px;

  &:hover {
    background: #e2dffd;
  }

  &:focus,
  active {
    background: #c6c0fc;
  }
  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const CardBodySection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const CardTitle = styled.div`
  color: #161d1f;
  display: flex;
  width: 100%;
  gap: 4px;
  align-items: center;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
`;

export const CardList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0 0 0 28px;
  justify-content: center;
  align-items: flex-start;
  color: #4f6168;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  list-style-type: disc;
  padding: 0 0 0 15px;
`;
